import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { ClickAwayListener, Grow, Popper } from '@material-ui/core'
import ScrollContent from '../../../molecules/ScrollContent'
import { KEYS } from '../../../../constants'
import SelectMenuOption from './SelectMenuOption'

function TypePopoverMenu ({
  anchorEl,
  open,
  setOpen,
  onSelect,
  options
}) {
  const handleClose = useCallback(() => setOpen(false), [setOpen])
  const handleEscape = useCallback((e) => {
    if (open && e.which === KEYS.ESC) {
      setOpen(false)
      e.stopPropagation()
      e.preventDefault()
    }
  }, [open, setOpen])

  const handleSelect = useCallback((value) => {
    onSelect(value)
    handleClose()
  }, [onSelect, handleClose])

  // hotkey handlers
  useEffect(() => {
    const handler = (e) => {
      handleEscape(e)
    }
    window.addEventListener('keydown', handler, false)
    return () => {
      window.removeEventListener('keydown', handler, false)
    }
  }, [handleEscape])

  const animateMenu = useCallback(({ TransitionProps, placement }) => {
    return (
      <Grow {...TransitionProps} style={{ transformOrigin: 'top' }}>
        <ScrollContent className='opal-drop-menu below select-none' maxHeight='300px'>
          <ClickAwayListener onClickAway={handleClose}>
            <div className='flex flex-col' style={{ minWidth: '200px' }}>
              {(options || []).map(option => (
                <SelectMenuOption
                  key={`mi_${option.value}`}
                  option={option}
                  onClick={handleSelect}
                  icon={option.icon}
                  hideAvatar
                  className='p-sm font-size-xs'
                />
              ))}
              {((options || []).length) === 0 ? (
                <div className='p-sm flex justify-center font-size-sm'>
                  No results
                </div>
              ) : null}
            </div>
          </ClickAwayListener>
        </ScrollContent>
      </Grow>
    )
  }, [handleClose, handleSelect, options])

  return (
    <Popper
      transition
      open={open}
      placement='bottom-start'
      className='z-index-dropdown'
      anchorEl={anchorEl}
    >
      {animateMenu}
    </Popper>
  )
}

TypePopoverMenu.propTypes = {
  anchorEl: PropTypes.any,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  options: PropTypes.array,
  onSearchChange: PropTypes.func,
  onSelect: PropTypes.func
}

export default TypePopoverMenu
